module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-2000-with-gift-fdfa8369.png";